import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const conflictsModule = {
  namespaced: true,
  state() {
    return {
      conflicts: [],
    };
  },
  actions,
  mutations,
  getters,
};

export default conflictsModule;
